// src/pages/qc/PipelineCreateModal.jsx
import { useState } from "react";
import { todayDubai } from "../../utils/dateUtils";
import { PRODUCT_TYPES, STAGES, STATUSES } from "./PageRdPipeline";

export function PipelineCreateModal({ project, onSave, onCancel }) {
  const isEdit = !!project;
  const stageNotesPassthrough = project?.stageNotes ?? null;
  const [form, setForm] = useState({
    name:        project?.name        ?? "",
    productType: project?.productType ?? "",
    description: project?.description ?? "",
    assignedTo:  project?.assignedTo  ?? "",
    priority:    project?.priority    ?? "MEDIUM",
    stage:       project?.stage       ?? "CONCEPT",
    status:      project?.status      ?? "ACTIVE",
    startDate:   project?.startDate   ?? todayDubai(),
    targetDate:  project?.targetDate  ?? "",
    notes:       project?.notes       ?? "",
  });
  const [saving, setSaving] = useState(false);
  const [error,  setError]  = useState(null);

  function set(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    setError(null);
    try {
      const body = {
        ...form,
        startDate:   form.startDate  || null,
        targetDate:  form.targetDate || null,
        productType: form.productType || null,
        assignedTo:  form.assignedTo  || null,
        stageNotes:  stageNotesPassthrough,
      };
      await onSave(body);
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  }

  return (
    <div className="modal" style={{ width: 620 }}>
      <div className="modal-header">
        <div className="modal-title">{isEdit ? "Edit Project" : "New R&D Project"}</div>
        <button className="modal-close" onClick={onCancel}>✕</button>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="modal-body">

          <div style={{ fontWeight: 600, fontSize: 12, color: "#1a3a6b",
            borderBottom: "2px solid #1a3a6b", marginBottom: 12, paddingBottom: 4 }}>
            Project Details
          </div>

          <div className="form-group">
            <label className="form-label">Project Name *</label>
            <input className="form-input" required value={form.name}
              onChange={e => set("name", e.target.value)} />
          </div>

          <div className="form-row">
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">Product Type</label>
              <select className="form-select" value={form.productType}
                onChange={e => set("productType", e.target.value)}>
                <option value="">— Select —</option>
                {PRODUCT_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">Priority</label>
              <select className="form-select" value={form.priority}
                onChange={e => set("priority", e.target.value)}>
                <option value="HIGH">High</option>
                <option value="MEDIUM">Medium</option>
                <option value="LOW">Low</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Target Application / Description</label>
            <textarea className="form-input" rows={3} value={form.description}
              onChange={e => set("description", e.target.value)} />
          </div>

          <div style={{ fontWeight: 600, fontSize: 12, color: "#1a3a6b",
            borderBottom: "2px solid #1a3a6b", marginBottom: 12, paddingBottom: 4, marginTop: 16 }}>
            Stage &amp; Timeline
          </div>

          <div className="form-row">
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">Stage</label>
              <select className="form-select" value={form.stage}
                onChange={e => set("stage", e.target.value)}>
                {STAGES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
              </select>
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">Status</label>
              <select className="form-select" value={form.status}
                onChange={e => set("status", e.target.value)}>
                {STATUSES.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">Start Date</label>
              <input className="form-input" type="date" value={form.startDate}
                onChange={e => set("startDate", e.target.value)} />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">Target Completion Date</label>
              <input className="form-input" type="date" value={form.targetDate}
                onChange={e => set("targetDate", e.target.value)} />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label className="form-label">Assigned To</label>
              <input className="form-input" placeholder="Chemist name"
                value={form.assignedTo} onChange={e => set("assignedTo", e.target.value)} />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Notes</label>
            <textarea className="form-input" rows={2} value={form.notes}
              onChange={e => set("notes", e.target.value)} />
          </div>

          {error && <div className="alert-warn">{error}</div>}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
          <button type="submit" className="btn btn-primary" disabled={saving}>
            {saving ? "Saving…" : isEdit ? "Save Changes" : "Create Project"}
          </button>
        </div>
      </form>
    </div>
  );
}
